import { Component } from "@angular/core";
import { MdDialogRef } from "@angular/material";

@Component({
  selector: "confirm-password-set",
  template: require("./confirm-password-set-dialog.component.html"),
  styles: [require("./confirm-password-set-dialog.component.scss")]
})
export class ConfirmPasswordSetDialogComponent {
  public constructor(
    public dialog: MdDialogRef<ConfirmPasswordSetDialogComponent>
  ) {}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/forgot-password/confirm-password-set-dialog/confirm-password-set-dialog.component.ts